__webpack_public_path__ =
  // eslint-disable-next-line no-restricted-globals
  JSON.parse(document.getElementById("config").innerText).staticURI || "/";
